import React, { useEffect, useState } from 'react'
import { Redirect, useHistory } from 'react-router-dom'
import styled from 'styled-components'
import { useGeneralContext } from './contexts/GeneralContext'
import { navDirections } from './utils/navDirections'
import RadioObjective from './partials/RadioObjective'
import ChevronRightRoundedIcon from '@material-ui/icons/ChevronRightRounded'
import ChevronLeftRoundedIcon from '@material-ui/icons/ChevronLeftRounded'
import {
    Container,
    Drawer,
    List,
    ListItem,
    ListItemIcon
} from '@material-ui/core'
import { DB, REAL_DB } from '../firebase'
import { useAuthContext } from './contexts/AuthContext'

function ExamPage() {
    const [activeQuestion, setActiveQuestion] = useState(0)
    const [open, setOpen] = useState(false)
    const [answers, setAnswers] = useState({})

    const { examSelected, createTimeStampInDB } = useGeneralContext()
    const { userDetails } = useAuthContext()

    const [difference, setDifference] = useState('')
    const [timeLeft, setTimeLeft] = useState('')

    const history = useHistory()

    const options = ['A', 'B', 'C', 'D']

    async function getOriginalTimeLeft() {
        const dbRef = REAL_DB.ref()
        await createTimeStampInDB()

        await dbRef
            .child('timestamps')
            .child(userDetails?.uid)
            .get()
            .then((snapshot) => {
                if (snapshot.exists()) {
                    const data = snapshot.val()

                    setDifference(
                        Math.floor(
                            (examSelected?.timeAtReal +
                                examSelected?.duration * 60 * 1000 -
                                data?.timestamp) /
                                1000
                        )
                    )
                } else {
                    console.log('No data available')
                }
            })
            .catch((error) => {
                console.error(error)
            })
    }

    function calculateTimeLeft() {
        const diff = difference - 1
        setDifference((prev) => (prev - 1 < 0 ? 0 : prev - 1))
        let time_left = {}

        if (diff > 0) {
            time_left = {
                min: Math.floor(diff / 60),
                sec: diff % 60
            }
        } else {
            endExamInDB()
            alert('Time Up')
            console.log('time finshed')

            history.push(navDirections.EXAMS_INSTANT_RESULT)
            return
        }

        return time_left
    }

    function endExamNow() {
        endExamInDB()

        history.push(navDirections.EXAMS_INSTANT_RESULT)
    }

    function oneToZeroOne(num) {
        return num < 10 ? `0${num}` : num
    }

    useEffect(() => {
        !!examSelected && getOriginalTimeLeft()
    }, [examSelected])

    useEffect(() => {
        const timer = setTimeout(() => {
            !!examSelected && !!difference && setTimeLeft(calculateTimeLeft())
        }, 1000)

        return () => clearTimeout(timer)
    }, [timeLeft, difference, examSelected])

    const toggleDrawer = (event) => {
        if (
            event.type === 'keydown' &&
            (event.key === 'Tab' || event.key === 'Shift')
        ) {
            return
        }

        setOpen(false)
    }

    function handleNext() {
        setActiveQuestion((prev) =>
            prev + 1 > examSelected?.questions?.length - 1
                ? examSelected?.questions?.length - 1
                : prev + 1
        )
    }
    function handlePrev() {
        setActiveQuestion((prev) => (prev - 1 < 0 ? 0 : prev - 1))
    }

    function populateWithAnswers() {
        let answersObj = {}
        examSelected?.questions?.forEach((element, index) => {
            answersObj[index] = {
                myAnswer: '',
                correctAnswer: options[parseInt(element?.ans)]
            }
        })
        return answersObj
    }

    function setDataToDB() {
        if (!!!examSelected?.id || !!!userDetails) return

        REAL_DB.ref(`exams/${examSelected?.id}/${userDetails?.uid}`).set({
            name: userDetails?.name,
            rollNo: userDetails?.rollNo,
            answers: populateWithAnswers()
        })
    }
    function addAnswerToDB(ans) {
        REAL_DB.ref().update({
            [`exams/${examSelected?.id}/${userDetails?.uid}/answers/${activeQuestion}`]:
                {
                    myAnswer: ans,
                    correctAnswer:
                        options[
                            parseInt(
                                examSelected?.questions[activeQuestion]?.ans
                            )
                        ]
                }
        })
    }
    async function endExamInDB() {
        await DB.collection('onlineExams')
            .doc(examSelected?.id)
            .set(
                {
                    [userDetails?.uid]: true
                },
                { merge: true }
            )
    }

    function getFromDB() {
        if (!!!examSelected?.id || !!!userDetails?.uid) return
        const dbRef = REAL_DB.ref()

        dbRef
            .child('exams')
            .child(examSelected?.id)
            .child(userDetails?.uid)
            .on('value', (snapshot) => {
                const data = snapshot.val()
                if (data !== null) {
                    setAnswers(data?.answers)
                } else {
                    console.log('No Data Available')
                }
            })
    }
    function checkForDataInDB() {
        if (!!!examSelected?.id || !!!userDetails?.uid) return
        const checkForAnswerDbRef = REAL_DB.ref()

        checkForAnswerDbRef
            .child('exams')
            .child(examSelected?.id)
            .child(userDetails?.uid)
            .get()
            .then((snapshot) => {
                if (!!!snapshot.exists()) setDataToDB()
            })
            .catch((error) => {
                console.error(error)
            })
    }

    useEffect(() => {
        getFromDB()

        checkForDataInDB()
    }, [examSelected])

    function populate() {
        let arr = []

        for (let i = 0; i < examSelected?.questions?.length; i++) {
            arr.push(
                <ListItem
                    button
                    onClick={() => setActiveQuestion(i)}
                    disabled={i === activeQuestion}
                    style={{ maxWidth: '450px', margin: 'auto' }}
                >
                    <ListItemIcon>
                        <DrawerQnNo>{i + 1}</DrawerQnNo>
                    </ListItemIcon>
                    <RadioObjective
                        disabled
                        state={answers?.[i]?.myAnswer || ''}
                        options={options}
                    />
                </ListItem>
            )
        }
        return arr
    }

    if (!!!examSelected || !!!userDetails)
        return <Redirect to={navDirections.HOME} />

    return (
        <ExamContainer>
            <Heading>{examSelected?.title}</Heading>
            <QuestionNumberAndTime>
                <QuestionNumber>
                    {`Qn: ${oneToZeroOne(activeQuestion + 1)} / ${oneToZeroOne(
                        examSelected?.questions?.length || 0
                    )}`}
                </QuestionNumber>
                <RemainingTime>
                    {`${timeLeft?.min || 0}m ${timeLeft?.sec || 0}s `}
                    <span>remaining</span>
                </RemainingTime>
            </QuestionNumberAndTime>

            <ExamQuestionSection>
                <img
                    src={examSelected?.questions[activeQuestion]?.image}
                    alt="question"
                />
            </ExamQuestionSection>

            <DrawerAndOptions>
                <Container>
                    <RadioObjective
                        state={answers?.[activeQuestion]?.myAnswer || ''}
                        setState={addAnswerToDB}
                        options={options}
                    />
                    <DrawerContainer>
                        <Arrows onClick={handlePrev}>
                            <ChevronLeftRoundedIcon />
                        </Arrows>

                        <DrawerButton onClick={() => setOpen(true)}>
                            Drawer
                        </DrawerButton>

                        <Arrows onClick={handleNext}>
                            <ChevronRightRoundedIcon />
                        </Arrows>
                    </DrawerContainer>
                </Container>
            </DrawerAndOptions>
            <Drawer anchor="bottom" open={open} onClose={toggleDrawer}>
                <div onClick={toggleDrawer}>
                    <List style={{ background: '#2E2E53' }}>
                        <ListItem button>
                            <CloseButton>CLOSE</CloseButton>
                        </ListItem>
                    </List>

                    <List style={{ background: '#2E2E53' }}>
                        {populate().map((item, key) => (
                            <React.Fragment key={key}>{item}</React.Fragment>
                        ))}
                    </List>

                    <List style={{ background: '#2E2E53' }}>
                        <ListItem button>
                            <EndExamButton>
                                <CloseButton onClick={endExamNow}>
                                    END EXAM
                                </CloseButton>
                            </EndExamButton>
                        </ListItem>
                    </List>
                </div>
            </Drawer>
        </ExamContainer>
    )
}

const ExamContainer = styled.div`
    padding-top: 4.5rem;
    margin-bottom: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: #fff;
`

const Heading = styled.h1`
    text-align: center;
    color: #fff;
    padding: 1.2rem 0;
    font-size: 18px;
    z-index: 1;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    background-color: #2e2e53;
`

const QuestionNumberAndTime = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    color: #fff;
`

const QuestionNumber = styled.p`
    font-weight: 600;
    font-size: 16px;
    color: #fff;
`
const RemainingTime = styled.p`
    font-weight: 600;
    font-size: 16px;
    color: #fff;

    span {
        font-weight: 400;
        font-size: 14px;
    }
`
const ExamQuestionSection = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 400px;
    width: 100%;
    background: #fff;
    margin: 20px auto;
    margin-bottom: 180px;
    border-radius: 5px;
    min-height: 300px;
    > img {
        object-fit: contain;
        width: 100%;
    }
`
const DrawerAndOptions = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    max-width: 450px;
    margin: auto;
    width: 100%;
    position: fixed;
    z-index: 99;
    bottom: 62px;
    left: 0;
    right: 0;
    background: #2e2e53;
`
const DrawerContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin: 20px 0;
`
const Arrows = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    width: 50px;
    border-radius: 50%;

    background: linear-gradient(
            153.18deg,
            rgba(255, 255, 255, 0) 15.38%,
            rgba(255, 255, 255, 0.1) 91.27%
        ),
        linear-gradient(
            131.63deg,
            rgba(41, 43, 92, 0.6) 9.65%,
            rgba(40, 43, 92, 0.58) 93.77%
        ),
        linear-gradient(
            105.27deg,
            rgba(255, 255, 255, 0.105) 2.25%,
            rgba(154, 154, 154, 0.035) 49.02%,
            rgba(201, 201, 201, 0.07) 60.55%,
            rgba(255, 255, 255, 0.042) 68.44%,
            rgba(129, 143, 161, 0.0424448) 84.06%,
            rgba(0, 28, 65, 0) 100%
        );
    box-shadow: 0px 0px 0px -1px rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(22px);
    font-size: 20px;
    color: #fff;
`
const DrawerButton = styled.button`
    outline: none;
    border-radius: 6px;
    border: none;
    padding: 15px 20px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    color: #fff;
    font-family: inherit;
    font-size: 16px;
    width: 100%;
    margin: 0 20px;
    max-width: 150px;
    background: linear-gradient(
            131.63deg,
            rgba(41, 43, 92, 0.6) 9.65%,
            rgba(40, 43, 92, 0.58) 93.77%
        ),
        linear-gradient(
            105.27deg,
            rgba(255, 255, 255, 0.105) 2.25%,
            rgba(154, 154, 154, 0.035) 49.02%,
            rgba(201, 201, 201, 0.07) 60.55%,
            rgba(255, 255, 255, 0.042) 68.44%,
            rgba(129, 143, 161, 0.0424448) 84.06%,
            rgba(0, 28, 65, 0) 100%
        );
    box-shadow: 0px 0px 0px -1px rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(22px);
`

const DrawerQnNo = styled.div`
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    height: 35px;
    width: 35px;
    border: 2px dashed #fff;
    font-size: 16px;
    color: #fff;
    background: #2e2e53;
`

const CloseButton = styled.div`
    padding: 15px;
    width: 100%;
    text-align: center;
    font-weight: 600;
    background: #2e2e53;
    color: #fff;
`
const EndExamButton = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    > a {
        width: 100%;
        padding: 15px;
        text-align: center;
        font-weight: 600;
        background: #2e2e53;
        color: #fff;
        text-decoration: none;
    }
`

export default ExamPage
